import { defineMessages } from "react-intl";

const baseId = "t.components.filterTable.";

export default defineMessages({
  filter: {
    id: baseId + "filter",
    defaultMessage: "Filter",
  },
});

